import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        notifications: []
    },
    reducers: {
        addNotification(state, action) {
            const notification = {
                id: Date.now() + Math.random(),
                message: action.payload.message,
                severity: action.payload.severity || 'info', // 'success', 'error', 'warning', 'info'
                autoHideDuration: action.payload.autoHideDuration || 6000,
                ...action.payload
            };
            state.notifications.push(notification);
        },
        removeNotification(state, action) {
            state.notifications = state.notifications.filter(
                notification => notification.id !== action.payload
            );
        },
        clearNotifications(state) {
            state.notifications = [];
        }
    }
});

export const { addNotification, removeNotification, clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;

